/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import {
    RegistrationHistoryItemDto,
    DeviceDetailsDto,
    FirmwareHistoryListDto,
    FirmwareHistoryQueryParams,
    StatusHistoryListDto,
    StatusHistoryQueryParams,
    OperatorHistoryListDto,
    OperatorHistoryQueryParams,
} from '../api/devices/devicesClient.typing';
import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';

export enum DeviceDetailsActionType {
    OPEN_REGISTRY_DEVICE_CARD_PAGE = 'RegistryDeviceCard/ open page',

    FETCH_DEVICE_DETAILS_SUCCESS = 'RegistryDeviceCard/ fetch device details success',
    FETCH_DEVICE_DETAILS_ERROR = 'RegistryDeviceCard/ fetch device details error',

    FETCH_FIRMWARE_HISTORY = 'RegistryDeviceCard/ fetch firmware versions history',
    FETCH_FIRMWARE_HISTORY_SUCCESS = 'RegistryDeviceCard/ fetch firmware versions history success',
    FETCH_FIRMWARE_HISTORY_ERROR = 'RegistryDeviceCard/ fetch firmware versions history error',
    DOWNLOAD_FIRMWARE_HISTORY = 'RegistryDeviceCard/ download firmware versions history as excel',
    DOWNLOAD_FIRMWARE_HISTORY_SUCCESS = 'RegistryDeviceCard/ download firmware versions history as excel success',
    DOWNLOAD_FIRMWARE_HISTORY_ERROR = 'RegistryDeviceCard/ download firmware versions history as excel error',

    FETCH_STATUS_HISTORY = 'RegistryDeviceCard/ fetch status history',
    FETCH_STATUS_HISTORY_SUCCESS = 'RegistryDeviceCard/ fetch status history success',
    FETCH_STATUS_HISTORY_ERROR = 'RegistryDeviceCard/ fetch status history error',
    DOWNLOAD_STATUS_HISTORY = 'RegistryDeviceCard/ download status history as excel',
    DOWNLOAD_STATUS_HISTORY_SUCCESS = 'RegistryDeviceCard/ download status history as excel success',
    DOWNLOAD_STATUS_HISTORY_ERROR = 'RegistryDeviceCard/ download status history as excel error',

    FETCH_OPERATOR_HISTORY = 'RegistryDeviceCard/ fetch operator history',
    FETCH_OPERATOR_HISTORY_SUCCESS = 'RegistryDeviceCard/ fetch operator history success',
    FETCH_OPERATOR_HISTORY_ERROR = 'RegistryDeviceCard/ fetch operator history error',
    DOWNLOAD_OPERATOR_HISTORY = 'RegistryDeviceCard/ download operator history as excel',
    DOWNLOAD_OPERATOR_HISTORY_SUCCESS = 'RegistryDeviceCard/ operator status history as excel success',
    DOWNLOAD_OPERATOR_HISTORY_ERROR = 'RegistryDeviceCard/ operator status history as excel error',

    FETCH_REGISTRATION_HISTORY = 'RegistryDeviceCard/ fetch cashbox history',
    FETCH_REGISTRATION_HISTORY_SUCCESS = 'RegistryDeviceCard/ fetch cashbox history success',
    FETCH_REGISTRATION_HISTORY_ERROR = 'RegistryDeviceCard/ fetch cashbox history error',
    DOWNLOAD_REGISTRATION_HISTORY = 'RegistryDeviceCard/ download cashbox history as excel',
    DOWNLOAD_REGISTRATION_HISTORY_SUCCESS = 'RegistryDeviceCard/ cashbox status history as excel success',
    DOWNLOAD_REGISTRATION_HISTORY_ERROR = 'RegistryDeviceCard/ cashbox status history as excel error',

    EXIT_REGISTRY_DEVICE_CARD_PAGE = 'RegistryDeviceCard/ exit page',
    CHANGE_HISTORY_TAB = 'RegistryDeviceCard/ change history tab',
}

export const openRegistryDeviceCardAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.OPEN_REGISTRY_DEVICE_CARD_PAGE, factoryNumber);

export const fetchDeviceDetailsSuccessAction = (payload: DeviceDetailsDto) =>
    createAction(DeviceDetailsActionType.FETCH_DEVICE_DETAILS_SUCCESS, payload);

export const fetchDeviceDetailsErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.FETCH_DEVICE_DETAILS_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const fetchFirmwareHistoryAction = (factoryNumber: string, params: FirmwareHistoryQueryParams) =>
    createAction(DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY, { factoryNumber, params });

export const fetchFirmwareHistorySuccessAction = (payload: FirmwareHistoryListDto) =>
    createAction(DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY_SUCCESS, payload);

export const fetchFirmwareHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.FETCH_FIRMWARE_HISTORY_ERROR, { notification });

export const downloadFirmwareHistoryAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY, factoryNumber);

export const downloadFirmwareHistorySuccessAction = () =>
    createAction(DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY_SUCCESS);

export const downloadFirmwareHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_FIRMWARE_HISTORY_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const fetchStatusHistoryAction = (factoryNumber: string, params: StatusHistoryQueryParams) =>
    createAction(DeviceDetailsActionType.FETCH_STATUS_HISTORY, { factoryNumber, params });

export const fetchStatusHistorySuccessAction = (payload: StatusHistoryListDto) =>
    createAction(DeviceDetailsActionType.FETCH_STATUS_HISTORY_SUCCESS, payload);

export const fetchStatusHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.FETCH_STATUS_HISTORY_ERROR, { notification });

export const downloadStatusHistoryAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY, factoryNumber);

export const downloadStatusHistorySuccessAction = () =>
    createAction(DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY_SUCCESS);

export const downloadStatusHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_STATUS_HISTORY_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const fetchOperatorHistoryAction = (factoryNumber: string, params: OperatorHistoryQueryParams) =>
    createAction(DeviceDetailsActionType.FETCH_OPERATOR_HISTORY, { factoryNumber, params });

export const fetchOperatorHistorySuccessAction = (payload: OperatorHistoryListDto) =>
    createAction(DeviceDetailsActionType.FETCH_OPERATOR_HISTORY_SUCCESS, payload);

export const fetchOperatorHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.FETCH_OPERATOR_HISTORY_ERROR, { notification });

export const downloadOperatorHistoryAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY, factoryNumber);

export const downloadOperatorHistorySuccessAction = () =>
    createAction(DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY_SUCCESS);

export const downloadOperatorHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_OPERATOR_HISTORY_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const fetchRegistrationHistoryAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY, factoryNumber);

export const fetchRegistrationHistorySuccessAction = (payload: RegistrationHistoryItemDto[]) =>
    createAction(DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY_SUCCESS, payload);

export const fetchRegistrationHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.FETCH_REGISTRATION_HISTORY_ERROR, { notification });

export const downloadRegistrationHistoryAction = (factoryNumber: string) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY, factoryNumber);

export const downloadRegistrationHistorySuccessAction = () =>
    createAction(DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY_SUCCESS);

export const downloadRegistrationHistoryErrorAction = (notification: Notification) =>
    createAction(DeviceDetailsActionType.DOWNLOAD_REGISTRATION_HISTORY_ERROR, { notification });

//-------------------------------------------------------------------------------------

export const exitRegistryDeviceCardAction = () => createAction(DeviceDetailsActionType.EXIT_REGISTRY_DEVICE_CARD_PAGE);

export const changeHistoryTabAction = (value: number) =>
    createAction(DeviceDetailsActionType.CHANGE_HISTORY_TAB, value);

export type DeviceDetailsAction =
    | ReturnType<typeof openRegistryDeviceCardAction>
    | ReturnType<typeof fetchDeviceDetailsSuccessAction>
    | ReturnType<typeof fetchDeviceDetailsErrorAction>
    | ReturnType<typeof fetchFirmwareHistoryAction>
    | ReturnType<typeof fetchFirmwareHistorySuccessAction>
    | ReturnType<typeof fetchFirmwareHistoryErrorAction>
    | ReturnType<typeof downloadFirmwareHistoryAction>
    | ReturnType<typeof downloadFirmwareHistorySuccessAction>
    | ReturnType<typeof downloadFirmwareHistoryErrorAction>
    | ReturnType<typeof fetchStatusHistoryAction>
    | ReturnType<typeof fetchStatusHistorySuccessAction>
    | ReturnType<typeof fetchStatusHistoryErrorAction>
    | ReturnType<typeof downloadStatusHistoryAction>
    | ReturnType<typeof downloadStatusHistorySuccessAction>
    | ReturnType<typeof downloadStatusHistoryErrorAction>
    | ReturnType<typeof fetchOperatorHistoryAction>
    | ReturnType<typeof fetchOperatorHistorySuccessAction>
    | ReturnType<typeof fetchOperatorHistoryErrorAction>
    | ReturnType<typeof downloadOperatorHistoryAction>
    | ReturnType<typeof downloadOperatorHistorySuccessAction>
    | ReturnType<typeof downloadOperatorHistoryErrorAction>
    | ReturnType<typeof fetchRegistrationHistoryAction>
    | ReturnType<typeof fetchRegistrationHistorySuccessAction>
    | ReturnType<typeof fetchRegistrationHistoryErrorAction>
    | ReturnType<typeof downloadRegistrationHistoryAction>
    | ReturnType<typeof downloadRegistrationHistorySuccessAction>
    | ReturnType<typeof downloadRegistrationHistoryErrorAction>
    | ReturnType<typeof exitRegistryDeviceCardAction>
    | ReturnType<typeof changeHistoryTabAction>;
